import { render, staticRenderFns } from "./AggregateDefinition.vue?vue&type=template&id=545190ac&scoped=true&"
import script from "./AggregateDefinition.vue?vue&type=script&lang=js&"
export * from "./AggregateDefinition.vue?vue&type=script&lang=js&"
import style0 from "./AggregateDefinition.vue?vue&type=style&index=0&id=545190ac&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545190ac",
  null
  
)

export default component.exports